/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIBillAutocompleteSuggestion
 */
export interface APIBillAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIBillAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIBillAutocompleteSuggestion
     */
    contractId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillAutocompleteSuggestion
     */
    requestCertificate?: string;
    /**
     * 
     * @type {number}
     * @memberof APIBillAutocompleteSuggestion
     */
    amount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIBillAutocompleteSuggestion
     */
    paid?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIBillAutocompleteSuggestion
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillAutocompleteSuggestion
     */
    contactName?: string;
}

/**
 * Check if a given object implements the APIBillAutocompleteSuggestion interface.
 */
export function instanceOfAPIBillAutocompleteSuggestion(value: object): value is APIBillAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIBillAutocompleteSuggestionFromJSON(json: any): APIBillAutocompleteSuggestion {
    return APIBillAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIBillAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contractId': json['contract_id'] == null ? undefined : json['contract_id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'contactName': json['contact_name'] == null ? undefined : json['contact_name'],
    };
}

export function APIBillAutocompleteSuggestionToJSON(value?: APIBillAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'contract_id': value['contractId'],
        'request_certificate': value['requestCertificate'],
        'amount': value['amount'],
        'paid': value['paid'],
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString().substring(0,10)),
        'contact_name': value['contactName'],
    };
}

